// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1s4S4","icon":"styles_icon__2eXvS"};